import { Field, FieldFooter } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ProjectGroupPicker } from 'components';

interface IProjectGroupFormFieldProps {
  className?: string | object;
  form: any;
  name: string;
  onChange?: (value: string | null) => void;
  validations?: any;
  autofocus?: boolean;
}

function ProjectGroupFormField(props: IProjectGroupFormFieldProps) {
  const { form, name, validations, className, onChange, ...other } = props;

  const classes = classNames(
    {
      'project-picker-form-field': true,
    },
    className
  );

  function renderField({ ...fieldProps }) {
    function handleOnSelect(val: string | null) {
      fieldProps.handleChange(val, onChange);
    }

    return (
      <>
        <ProjectGroupPicker
          error={fieldProps.hasError}
          value={form.state.data[name]}
          onSelect={handleOnSelect}
          {...other}
        />
        <FieldFooter errorMessage={fieldProps.errorMessage} hasError={fieldProps.hasError} />
      </>
    );
  }

  return <Field form={form} name={name} validations={validations} className={classes} render={renderField} />;
}

export default ProjectGroupFormField;
